import * as React from "react";
import { useMemo } from "react";
import { SearchSpringResults } from "../types";
import Carousel from "./Carousel";

interface Props {
  data: SearchSpringResults;
}

export default function SearchSpringView({ data }: Props) {
  const priceFormatter = useMemo(
    () =>
      new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }),
    []
  );

  return (
    <div>
      <Carousel itemsPerSlide={2}>
        {data.Results.length > 0 &&
          data.Results.map((item, i) => (
            <div className="search-spring-item" key={i}>
              <div>
                <img src={item.ImageUrl} />
              </div>
              <div className="item-desc">
                <div>
                  <b>{item.Name}</b>
                  <div style={{ lineHeight: "1.5em" }}>{item.Brand}</div>
                </div>
                <div>
                  <i>{priceFormatter.format(item.Price)}</i>
                </div>
              </div>
            </div>
          ))}
        {data.Results.length === 0 && <div>No products found.</div>}
      </Carousel>
    </div>
  );
}
